"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const format_1 = require("ol/format");
const extent_1 = require("ol/extent");
const Map_js_1 = __importDefault(require("ol/Map.js"));
const View_1 = __importDefault(require("ol/View"));
const LineString_1 = __importDefault(require("ol/geom/LineString"));
const empty = {
    projection: { dataProjection: '', featureProjection: '' },
    multiPolygon: '',
    extent: [],
    map: new Map_js_1.default(),
    notFly: false,
};
class Center {
    constructor(config = empty) {
        this.oldExtent = [];
        this.projection = config.projection;
        this.multiPolygon = config.multiPolygon;
        this.extent = config.extent || [];
        this.map = config.map;
        this.notFly = config.notFly || empty.notFly;
    }
    center() {
        if (this.extent && this.extent.length > 0) {
            this.fitMapCenter(this.extent);
        }
        else {
            const format = new format_1.WKT();
            const feature = format.readFeature(this.multiPolygon, {
                dataProjection: this.projection.dataProjection,
                featureProjection: this.projection.featureProjection,
            });
            const extent = feature.getGeometry().getExtent();
            this.fitMapCenter(extent);
        }
    }
    fitMapCenter(extent) {
        if (JSON.stringify(this.oldExtent) !== JSON.stringify(extent)) {
            const map = this.map;
            const location = (0, extent_1.getCenter)(extent);
            const view = this.map.getView();
            const center = view.getCenter();
            const distance = this.distanceBetweenPoints(location, center);
            const newView = new View_1.default({
                zoom: view.getZoom(),
                center: center,
                extent: [-20037508.34, -20037508.34, 20037508.34, 20037508.34],
            });
            map.setView(newView);
            if (distance > 15000 && this.oldExtent && !this.notFly) {
                this.flyTo(extent, map);
            }
            else {
                this.softZomm(extent, map);
            }
            this.oldExtent = extent;
        }
    }
    distanceBetweenPoints(latlng1, latlng2) {
        const line = new LineString_1.default([latlng1, latlng2]);
        return Math.round(line.getLength() * 100) / 100;
    }
    softZomm(extent, map) {
        const view = map.getView();
        const resolution = view.getResolutionForExtent(extent);
        const zoom = view.getZoomForResolution(resolution);
        const maxZoom = 19;
        view.animate({
            zoom: zoom <= maxZoom ? zoom - 0.5 : maxZoom,
            center: (0, extent_1.getCenter)(extent),
            duration: 1000,
        }, () => {
            const extent = map.getView().calculateExtent(map.getSize());
            const newView = new View_1.default({
                zoom: zoom <= maxZoom ? zoom - 0.5 : maxZoom,
                maxZoom: 18,
                minZoom: zoom <= maxZoom ? zoom - 1 : 17,
                center: (0, extent_1.getCenter)(extent),
                extent: extent,
            });
            map.setView(newView);
        });
    }
    flyTo(extent, map) {
        const view = map.getView();
        const resolution = view.getResolutionForExtent(extent);
        const zoom = view.getZoomForResolution(resolution);
        const maxZoom = 19;
        view.animate({
            zoom: map.getView().getZoom() - 2,
            duration: 2500,
        }, () => {
            view.animate({
                zoom: zoom <= maxZoom ? zoom - 2 : 18,
                center: (0, extent_1.getCenter)(extent),
                duration: 2000,
            }, () => {
                view.animate({
                    zoom: zoom <= maxZoom ? zoom - 0.5 : maxZoom,
                    center: (0, extent_1.getCenter)(extent),
                    duration: 1500,
                }, () => {
                    const extent = map.getView().calculateExtent(map.getSize());
                    const newView = new View_1.default({
                        zoom: zoom <= maxZoom ? zoom - 0.5 : maxZoom,
                        maxZoom: 18,
                        minZoom: zoom <= maxZoom ? zoom - 1 : 17,
                        center: (0, extent_1.getCenter)(extent),
                        extent: extent,
                    });
                    map.setView(newView);
                });
            });
        });
    }
}
exports.default = Center;
